interface Options {
  src: string | null;
  width?: number;
  height?: number;
  /** Default value 'cover' */
  fit?: 'scale-down' | 'contain' | 'cover' | 'crop' | 'pad';
  /** Default value 80 */
  quality?: number;
}

export const BASE_URL = 'https://simplywall.st';

export function getStaticUrl(file: string) {
  return `${BASE_URL}/static/images/${file}`;
}

export function getCloudflareImageUrl({
  src,
  width,
  height,
  fit = 'cover',
  quality = 80,
}: Options) {
  if (src === '' || src === null) return '';
  let dimensions = '';
  if (typeof width === 'number') {
    dimensions += `w=${width},`;
  }
  if (typeof height === 'number') {
    dimensions += `h=${height},`;
  }
  /** More info on https://developers.cloudflare.com/image-resizing/url-format */
  return `${BASE_URL}/cdn-cgi/image/format=auto,fit=${fit},${dimensions}q=${quality}/${src}`;
}

export function useCloudflareImage(options: Options) {
  return getCloudflareImageUrl(options);
}

interface ResponsiveOptions {
  src: string | null;
  /** just width or {width, height} */
  breakpoints:
    | number[]
    | { width: number; height: number; fit?: Options['fit'] }[];
}
export function getResponsiveImage(options: ResponsiveOptions) {
  return {
    srcSet: options.breakpoints
      .map((breakpoint) => {
        if (typeof breakpoint === 'number') {
          return `${getCloudflareImageUrl({
            src: options.src,
            width: breakpoint,
          })} ${breakpoint}w`;
        } else {
          return `${getCloudflareImageUrl({
            src: options.src,
            width: breakpoint.width,
            height: breakpoint.height,
            fit: breakpoint.fit || 'cover',
          })} ${breakpoint.width}w`;
        }
      })
      .join(','),
  };
}
